/*
 * @Description:
 * @Date: 2022-07-26 11:51:41
 */
export const MAX_IMAGE_SIZE = 1024 * 1024 * 5; // 最大图片size
